import useApi from './useApi';

const useApplicationService = () => {
  const api = useApi();

  const getApplication = async () => await api.get(`/application/`);
  const getVersion = async () => await api.get(`/application/version`);

  return {
    getApplication,
    getVersion,
  };
};

export default useApplicationService;
